import { render } from "./learningCenterMobileTab.vue?vue&type=template&id=5c53df0c"
import script from "./learningCenterMobileTab.vue?vue&type=script&lang=js"
export * from "./learningCenterMobileTab.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./learningCenterMobileTab.vue?vue&type=style&index=0&id=5c53df0c&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__